import React, { lazy } from 'react';
// Cloudinary transformation: f_auto (best format), q_auto (auto quality), w_300 (300px width — 2x of rendered ~150px)
const CLD = 'https://res.cloudinary.com/dowzlbqlz/image/upload/f_auto,q_auto,w_300';
const tomes = [{
  label: 'Tomo 1',
  sublabel: 'El Filtro',
  image: `${CLD}/v1777941749/hf_20260505_003702_f81dcb43-9c9d-4ab6-91f8-d74449f2cd97_1_hez7l7.webp`
}, {
  label: 'Tomo 2',
  sublabel: 'El Cuerpo',
  image: `${CLD}/v1777941780/hf_20260505_003759_86c18603-67ee-4c3b-b403-89f0583c8344_x8pttl.jpg`
}, {
  label: 'Tomo 3',
  sublabel: 'El Inconsciente',
  image: `${CLD}/v1777941825/hf_20260505_004208_441c28f6-9f2d-445b-80c3-2e2090ae9556_ywd1yv.webp`
}, {
  label: 'Tomo 4',
  sublabel: 'El Desarrollo',
  image: `${CLD}/v1777941926/hf_20260505_004250_f2def6e2-48f5-46da-be63-ae116f132bfa_zs85ng.webp`
}, {
  label: 'Tomo 5',
  sublabel: 'La Clínica',
  image: `${CLD}/v1777941950/hf_20260505_004424_0660bc12-3013-4296-ac13-fd0a51e40a50_r2nihc.webp`
}, {
  label: 'Tomo 6',
  sublabel: 'El Sistema Social',
  image: `${CLD}/v1777941953/hf_20260505_004432_1e7df21d-00cd-4210-ae02-c00d5f47b99a_ineuka.webp`
}];
const features = ['Todo el contenido de la carrera organizado por etapa y materia', 'Esquemas, cuadros comparativos y mapas conceptuales listos para estudiar', 'Guías de estudio por materia con lo esencial para cada parcial y final', 'Scripts de examen y simulacros para practicar antes de rendir'];
export function ProductShowcase() {
  return <section className="relative w-full px-4 sm:px-6 lg:px-8 py-10 text-base leading-6" style={{
    background: 'linear-gradient(180deg, #FEFAF4 0%, #FEFAF4 15%, #FDF4E7 85%, #FDF4E7 100%)'
  }} data-id="element-260">
      <div className="mx-auto max-w-4xl text-center" data-id="element-261">
        {/* Badge */}
        <div className="mb-6 inline-flex items-center gap-2 text-xs font-bold tracking-wide rounded-full px-4 py-1.5" style={{
        color: '#7A9E7E',
        border: '1px solid rgba(122,158,126,0.45)',
        backgroundColor: 'rgba(122,158,126,0.08)'
      }} data-id="element-262">
          🏆 El sistema de estudio más completo para estudiantes de Psicología
          en Argentina
        </div>

        {/* Subtitle */}
        <h3 className="text-xl font-bold m-0 mb-4" style={{
        color: '#C8922A'
      }} data-id="element-263">
          MEGAPACK PSICOLOGÍA: CARRERA RESUELTA
        </h3>

        {/* Description */}
        <p className="max-w-2xl mx-auto m-0 mb-8 text-[14px]" style={{
        color: '#1E1208'
      }} data-id="element-264">
          <strong data-id="element-265">
            6 Tomos + 6 Bonos — Sistema de Organización Completo — Toda la
            carrera resuelta.
          </strong>
          <br data-id="element-266" />
          +360 páginas · Del primer día de cursada al último final · Historia,
          Neurociencias, Psicoanálisis, Desarrollo, Clínica y Psicología Social
          · Esquemas y cuadros comparativos · Guías por materia · Scripts de
          examen · 100% adaptado al plan de estudios argentino.
        </p>

        {/* Tomes Grid */}
        <div className="relative mx-auto max-w-3xl mb-12" data-id="element-267">
          <div className="grid grid-cols-6 gap-3" data-id="element-268">
            {tomes.map(tome => <div key={tome.label} className="flex flex-col items-center gap-2" data-id="element-269">
                <div className="w-full aspect-[3/4] rounded-xl overflow-hidden shadow-lg" style={{
              border: '1px solid rgba(200,146,42,0.18)'
            }} data-id="element-270">
                  <img src={tome.image} alt={`${tome.label} — ${tome.sublabel}`} width={180} height={240} loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-271" />
                </div>
                <div className="text-center" data-id="element-272">
                  <span className="block text-[11px] sm:text-xs font-black" style={{
                color: '#1E1208'
              }} data-id="element-273">
                    {tome.label}
                  </span>
                  <span className="block text-[9px] sm:text-[10px] leading-tight mt-0.5" style={{
                color: '#9A7B5A'
              }} data-id="element-274">
                    {tome.sublabel}
                  </span>
                </div>
              </div>)}
          </div>

          {/* Badge inferior */}
          <div className="mt-6 flex justify-center" data-id="element-275">
            <div className="whitespace-nowrap text-[10px] font-black text-white rounded-full px-4 py-1.5 shadow-sm" style={{
            background: 'linear-gradient(135deg, #B8860B 0%, #C8922A 50%, #7A9E7E 100%)'
          }} data-id="element-276">
              6 TOMOS COMPLETOS · DEL PRIMER DÍA AL ÚLTIMO FINAL
            </div>
          </div>
        </div>

        {/* Feature Tags */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-2xl mx-auto" data-id="element-277">
          {features.map(feature => <div key={feature} className="flex items-center gap-2.5 rounded-xl px-4 py-3 text-left" style={{
          backgroundColor: 'rgba(122,158,126,0.07)',
          border: '1px solid rgba(122,158,126,0.22)'
        }} data-id="element-278">
              <span className="flex-shrink-0 w-5 h-5 rounded-full flex items-center justify-center" style={{
            backgroundColor: 'rgba(122,158,126,0.18)'
          }} data-id="element-279">
                <svg className="w-3 h-3" style={{
              color: '#7A9E7E'
            }} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3} data-id="element-280">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-281" />
                </svg>
              </span>
              <span className="text-xs font-semibold leading-snug" style={{
            color: '#1E1208'
          }} data-id="element-282">
                {feature}
              </span>
            </div>)}
        </div>
      </div>

      {/* Degradé inferior → conecta con WhatYouGet */}
      <div className="absolute bottom-0 left-0 w-full h-16 pointer-events-none" style={{
      background: 'linear-gradient(180deg, transparent 0%, #FDF4E7 100%)'
    }} data-id="element-283" />
    </section>;
}